// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import React from 'react';
import type { RichTextSectionContent } from '../../../types/proposal';
import { sanitizeHtml } from './sanitizeHtml';

interface Props {
  readonly content: RichTextSectionContent;
}

/**
 * SUSTAINABILITY / PRECAUTIONS / NEXT_STEPS / DECLARATIONS / APPENDICES —
 * advisor-authored HTML blocks, sanitized through the conservative
 * allowlist before rendering (see sanitizeHtml.ts).
 */
const PlanRichTextSection: React.FC<Props> = ({ content }) => {
  const blocks = content.blocks ?? [];
  return (
    <div data-testid="plan-rich-text">
      {blocks.map((block, i) => (
        <div className="proposal-plan__rich-block" key={i}>
          {block.title && <div className="proposal-plan__card-title">{block.title}</div>}
          <div
            className="proposal-plan__rich-html"
            data-testid="plan-rich-text-block"
            // Safe: sanitized through the allowlist sanitizer above.
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(block.html) }}
          />
        </div>
      ))}
    </div>
  );
};

export default PlanRichTextSection;
